import React, { useState } from "react";
import { REJECT_REASONS, MAX_REJECT_NOTE } from "../constants/rejectReasons";

// Inline form an admin fills in before rejecting. The contributor sees the reason in their notifications.
export default function RejectForm({ what = "this", busy, onConfirm, onCancel }) {
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const needsNote = reason === "other";
  const ready = (reason || note.trim()) && !(needsNote && !note.trim());

  const submit = (e) => {
    e.preventDefault();
    if (ready && !busy) onConfirm({ reason, note: note.trim() });
  };

  return (
    <form className="reject-form" onSubmit={submit}>
      <label>
        <span>Why are you rejecting {what}? <em>The contributor will see this.</em></span>
        <select value={reason} onChange={(e) => setReason(e.target.value)} autoFocus>
          <option value="">Choose a reason…</option>
          {REJECT_REASONS.map((r) => <option key={r.id} value={r.id}>{r.label}</option>)}
        </select>
      </label>
      <label>
        <span>{needsNote ? "Explanation (required)" : "Extra detail (optional)"}</span>
        <textarea
          rows={3}
          maxLength={MAX_REJECT_NOTE}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="e.g. This is the same wreck as “SS Example”, please add your photos there instead."
        />
        <small>{note.length}/{MAX_REJECT_NOTE}</small>
      </label>
      <div className="review-actions">
        <button type="submit" className="review-btn reject" disabled={!ready || busy}>✕ Reject and notify</button>
        <button type="button" className="review-btn" disabled={busy} onClick={onCancel}>Cancel</button>
      </div>
    </form>
  );
}
